// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"26722c41","206":"2b859f75","241":"6a53c0a9","571":"bc5b5d19","582":"552063b3","707":"f5cb5a87","864":"79a23b19","876":"e0d5439b","901":"25738eec"}[chunkId] + ".chunk.js";
};